import React, { useState, useCallback } from 'react';
import { Shield, Heart, TrendingDown, Sparkles, Activity, Zap, ChevronRight } from 'lucide-react';
import './Benefits.css';
import { benefits } from '../mockData';

const iconMap = {
  1: Shield,
  2: Activity,
  3: TrendingDown,
  4: Sparkles,
  5: Heart,
  6: Zap
};

const VISIBLE_CARDS = 4;

const Benefits = () => {
  const [order, setOrder] = useState(benefits.map((_, i) => i));
  const [isAnimating, setIsAnimating] = useState(false);

  const handleNext = useCallback(() => {
    if (isAnimating) return;
    setIsAnimating(true);
    // Move front card to back
    setOrder(prev => [...prev.slice(1), prev[0]]);
    setTimeout(() => setIsAnimating(false), 400);
  }, [isAnimating]);

  return (
    <section id="benefits" className="benefits-section">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-2">Why Microgreens?</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', marginTop: '1rem' }}>
            Packed with nutrients, flavor, and health benefits
          </p>
        </div>

        <div className="benefits-deck-wrapper">
          <div
            className="benefits-deck"
            data-testid="benefits-card-deck"
            onClick={handleNext}
          >
            {order.map((benefitIndex, stackPos) => {
              const benefit = benefits[benefitIndex];
              const Icon = iconMap[benefit.id];
              const isVisible = stackPos < VISIBLE_CARDS;

              return (
                <div
                  key={benefit.id}
                  className={`deck-card ${stackPos === 0 ? 'deck-card-front' : ''}`}
                  data-testid={`benefit-card-${benefit.id}`}
                  style={{
                    zIndex: benefits.length - stackPos,
                    transform: isVisible
                      ? `translateY(${stackPos * 12}px) scale(${1 - stackPos * 0.04})`
                      : `translateY(${VISIBLE_CARDS * 12}px) scale(${1 - VISIBLE_CARDS * 0.04})`,
                    opacity: isVisible ? 1 - stackPos * 0.15 : 0,
                    pointerEvents: stackPos === 0 ? 'auto' : 'none',
                  }}
                >
                  <div className="deck-card-inner">
                    <div className="deck-card-icon">
                      <Icon size={36} strokeWidth={1.5} />
                    </div>
                    <div className="deck-card-text">
                      <h3 className="heading-3">{benefit.title}</h3>
                      <p className="body-medium">{benefit.description}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="deck-controls">
            <div className="deck-dots">
              {benefits.map((_, i) => (
                <span
                  key={i}
                  className={`deck-dot ${order[0] === i ? 'active' : ''}`}
                />
              ))}
            </div>
            <button
              className="deck-next-btn"
              onClick={handleNext}
              aria-label="Next benefit"
              data-testid="benefits-next-btn"
            >
              Tap to explore
              <ChevronRight size={18} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Benefits;
